export default function loginAction( data ) {
  return (dispatch) => {
    dispatch({
      type : 'LOGIN_ACTION',
      payload : data
    })
  }
}